export const QUICKBOOKS_INVOICE_STATUSES = [
  "queued",
  "waiting_dependency",
  "preparing",
  "submitting",
  "retry_wait",
  "reconciling",
  "succeeded",
  "failed",
  "needs_review",
  "blocked",
] as const;

export type QuickBooksInvoiceStatus =
  (typeof QUICKBOOKS_INVOICE_STATUSES)[number];

export interface QuickBooksInvoiceRequest {
  request_id: string;
  shipment_id: number;
  status: QuickBooksInvoiceStatus;
  message?: string | null;
  can_retry: boolean;
  can_replace?: boolean;
  generation?: number;
  status_url?: string | null;
  invoice_number?: string | null;
  solmaz_quickbooks_invoice_id?: string | null;
}

export interface QuickBooksInvoiceCapabilities {
  enabled: boolean;
}

export interface QuickBooksInvoiceApiErrorBody {
  code?: string;
  message?: string;
  [key: string]: unknown;
}

export interface QuickBooksInvoiceApiError extends Error {
  status?: number;
  code?: string;
  retryAfter?: number;
  isNetworkError: boolean;
  isCanceled: boolean;
  body?: QuickBooksInvoiceApiErrorBody;
}

export type QuickBooksInvoiceLatest = QuickBooksInvoiceRequest | null;

export function isActiveInvoiceStatus(status?: QuickBooksInvoiceStatus): boolean {
  return status !== undefined && ["queued", "waiting_dependency", "preparing", "submitting", "retry_wait", "reconciling"].includes(status);
}

/** Use the same guard in the button and its action; unresolved results cannot create again. */
export function isInvoiceCreationBlocked(state?: {
  status?: QuickBooksInvoiceLatest;
  loading?: boolean;
  polling?: boolean;
  retrying?: boolean;
  error?: QuickBooksInvoiceApiError | null;
}): boolean {
  return Boolean(state?.loading || state?.polling || state?.retrying || state?.error || state?.status);
}
